module.exports = __webpack_public_path__ + "img/03Jefferson.c84dcf78.png";